import { render, staticRenderFns } from "./Globalpassword.vue?vue&type=template&id=385e8d5c"
import script from "./Globalpassword.vue?vue&type=script&lang=js"
export * from "./Globalpassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports